import React from 'react';
import { ProPage } from './pro_page';
import { ProPageSEO } from './pro_page_seo';

const ProPageContainer = () => {
  return (
    <>
      <ProPageSEO />
      <ProPage />
    </>
  );
};

export default ProPageContainer;
